module.exports = __webpack_public_path__ + "static/img/industry3.750dc57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industry3.png
// module id = IBV6
// module chunks = 0